import { ROLES } from "@/common/permissions";
import { ReactNode } from "react";
import { RoleProtectedRoute } from "./RoleProtectedRoute";

export function ManagerProtectedRoute({
  children,
}: {
  children: ReactNode;
}) {
  return <RoleProtectedRoute role={ROLES.MANAGER}>{children}</RoleProtectedRoute>;
} 